/**
 * Компонент прогресс-бара с вариантами стилей и размерами
 * Дата: 29.01.2026
 * Назначение: Отображение прогресса выполнения операций
 * Связан с: TODO-021a (mass_binding_enhancements)
 */
import { cn } from '@/utils/cn';

interface ProgressBarProps {
  value: number;           // 0-100 или 0-max
  max?: number;            // default 100
  label?: string;
  showPercent?: boolean;
  variant?: 'default' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  testId?: string;
}

const variantColors = {
  default: 'bg-blue-500',
  success: 'bg-green-500',
  warning: 'bg-orange-500',
  error: 'bg-red-500',
};

const sizes = {
  sm: 'h-1',
  md: 'h-2',
  lg: 'h-3',
};

export function ProgressBar({ 
  value, 
  max = 100, 
  label, 
  showPercent = true,
  variant = 'default',
  size = 'md',
  className,
  testId
}: ProgressBarProps) {
  const percent = Math.min(100, Math.max(0, (value / max) * 100));
  
  return (
    <div className={cn('w-full', className)} data-testid={testId}>
      {(label || showPercent) && (
        <div className="flex justify-between text-sm mb-1">
          {label && <span className="text-neutral-600">{label}</span>}
          {showPercent && <span className="text-neutral-500">{Math.round(percent)}%</span>}
        </div>
      )}
      <div className={cn('w-full bg-neutral-200 rounded-full overflow-hidden', sizes[size])}>
        <div 
          className={cn(
            variantColors[variant],
            sizes[size],
            'rounded-full transition-all duration-300'
          )}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
